import React from 'react';

const Definition = () => {
  return (
    <div className="container">
      <h1 className="page-title">Theory and Description</h1>

      <div className="section">
        <h2>Theory of Solution-Focused Practice</h2>
        <div style={{display: 'flex', gap: '2rem', alignItems: 'flex-start', flexWrap: 'wrap'}}>
          <div style={{flex: '1', minWidth: '300px'}}>
            <p><strong>In 2020 the EBTA Book "Theory of Solution-Focused Practice" was published.</strong></p>

            <p>This book is the result of the co-creative process within the EBTA Theory Group and community for some years. It is aiming at clear formulation of the theoretical reasoning around solution-focused practice. We still consider the carefully crafted text as a state of the art version of understanding and learning Solution-Focused Practice. However, we intentionally subtitled it with „Version 2020" to indicate our hope of other versions and future developments.</p>

            <p>The book presents a coherent theory of solution-focused practice which is applicable to various fields of practice, such as therapy, coaching, supervision, social change, educational work, leadership, and other contexts where a detailed understanding of how to manage and promote change in social systems and communities is intended. Theory here is defined as a process theory describing how the solution-focused practice is done, together with explanations of how and why the change process is initiated. It serves those who want to understand the rationale, together with a comprehensive description of solution-focused practice that can be used in daily practice or training and for developmental purposes or research.</p>

            <p>The book also includes additional reflections of six distinguished SF scholars.</p>

            <h3>Translations</h3>
            <p>The book has been translated into Dutch, Italian and Polish.</p>
            <p>If you are interested to do a translation we are happy to work together to publish it in as many languages as possible. Right now we are collaborating to get a French and Georgian translation published.</p>
            <p>Some parts of earlier versions of it are published in Finnish, German and French articles.</p>

            <p style={{marginTop: '1.5rem'}}>
              <a
                href="https://buchshop.bod.de/catalogsearch/result/?q=ebta"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#2563eb',
                  color: 'white',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: 600
                }}
              >
                Get your copy →
              </a>
            </p>
          </div>
          <div style={{flexShrink: 0}}>
            <img
              src={`${process.env.PUBLIC_URL}/images/boek.jpg`}
              alt="Theory of Solution-Focused Practice 2020 book cover"
              style={{
                maxWidth: '250px',
                width: '100%',
                height: 'auto',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
              }}
            />
          </div>
        </div>
      </div>

      <div className="section">
        <h2>Definition Solution Focused Brief Therapy</h2>
        <p>Solution Focused Brief Therapy (SFBT) is a therapeutic approach that focuses on meaningful descriptions of how persons will recognise their preferred future.</p>

        <p>This approach was created by a team around Insoo Kim Berg and Steve de Shazer and the Brief Family Therapy Center in Milwaukee during the early 1980s. Among the concepts and tools that are the basis of the therapeutic intervention, we can remember the pre-session change technique, looking for exceptions to the problem, the enhancement of skills, the miracle question, scaling questions and useful tasks to be given between sessions.</p>

        <p>SFBT adopts phenomenological and constructivist epistemology, which seeks to understand the meaning that people attribute to events and experiences.</p>

        <p>The therapist abandons the role of expert and avoids providing interpretations, which often contribute to define the "problem" in terms that make it even more difficult to solve. In fact, only clients can be recognized as true experts of themselves. Diagnostic evaluations are also restructured in order to highlight the strengths of people, in a constructivist perspective oriented towards change and solution.</p>

        <p>The EBTA Theory book (Sundman et al., 2020) is describing how the solution-focused practice is done, together with explanations of how and why the process is initiated, why it goes in a certain direction and who is responsible for it.</p>

        <p>A general definition of solution-focused practice in the different practice contexts given there is:</p>

        <blockquote style={{
          borderLeft: '4px solid #2563eb',
          paddingLeft: '1rem',
          margin: '1.5rem 0',
          fontStyle: 'italic',
          backgroundColor: '#f8fafc',
          padding: '1rem'
        }}>
          "Clients get support for the change they hope for from a practitioner based on the clients' resources, skills, strengths, future hopes and interaction in their environment. For the clients it means formulating and applying new orientations to self, others and the future. This is thus a theory of how to support a client's change." (Theory of Solution-Focused Practice, 2020, p.23)
        </blockquote>
      </div>
    </div>
  );
};

export default Definition;
